/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
} from 'reactstrap';
import { UPDATE_SUBSCRIPTION } from '../../mutation/mutation';
import { GET_USER_DATA } from '../../query/query';
import { formatDate, formatNotificationFailureReason } from '../../services/format-utils';
import SendResetPasswordEmail from './send-reset-password-email';
import ResetPassword from './reset-password';
import ReferralInfos from './referral-infos';

const amplitudeURL = 'https://analytics.amplitude.com/loveboxlove/activity';

const UserSubscription = ({
  onPressGiveFreePostcard,
  subscription: {
    subscribed, hasFreePostcard, platform,
  },
}) => (
  <div>
    <b>Subscription</b>
    {platform
      ? (
        <ul>
          <li>
            Status: <span style={styles.subscriptionStatus(subscribed)}>{subscribed ? 'Active' : 'Inactive'}</span>
          </li>
          <li>
            Has free postcard: {hasFreePostcard ? 'Yes' : 'No'}
            {!hasFreePostcard && (
              // eslint-disable-next-line
              <span onClick={onPressGiveFreePostcard} style={styles.giveFreePostcard}>
                Give free postcard
              </span>
            )}
          </li>
          <li>Platform: {platform}</li>
        </ul>
      )
      : <p>Never subscribed</p>}
  </div>
);

const UserDevices = ({ device }) => {
  const {
    os, appVersion,
    model, brand,
    osVersion, deviceType,
  } = device || {};

  return (
    <div>
      <b>Device:</b>
      <br />
      {(device) ? (
        <ul>
          <li>OS: {os}</li>
          <li>OS version: {osVersion}</li>
          <li>App version: {appVersion}</li>
          <li>Model: {model}</li>
          <li>Brand: {brand}</li>
          <li>Type: {deviceType}</li>
        </ul>
      ) : <p>unknown</p>}
    </div>
  );
};

const UserDataTable = ({ email, user, versions }) => {
  const [giveFreePostcard] = useMutation(UPDATE_SUBSCRIPTION, {
    update: (cache, { data: { savUpdateSubscription: newSubscription } }) => {
      const { savGetUserData } = cache.readQuery({
        query: GET_USER_DATA,
        variables: { email },
      });
      savGetUserData.subscription = {
        ...savGetUserData.subscription,
        ...newSubscription,
      };
      cache.writeQuery({
        query: GET_USER_DATA,
        variables: { email },
        data: { savGetUserData },
      });
    },
    variables: { subscriptionUpdate: { hasFreePostcard: true, userId: user._id } },
  });

  const formatTimezone = (timezone) => {
    if (timezone === null || timezone === undefined) {
      return '';
    }
    const sign = timezone > 0 ? '+' : '';
    return `UTC${sign}${timezone / 60}`;
  };

  return (
    <Container>
      <Row>
        <Col>
          <div>
            <div>
              <b>Name:</b> {user.firstname}
            </div>
            <div>
              <b>Timezone:</b> {formatTimezone(user.timezone)}
            </div>
            <div>
              <b>LoveCoins:</b> {user.loveCoins}
            </div>
            <div>
              <b>Reminders:</b> {user.settings && user.settings.loveGoal}
            </div>
            <div>
              <b>Reminders status:</b> {user.settings && user.settings.reminders ? 'Enabled' : 'Disabled'}
            </div>
            <div>
              <b>Streak:</b> {user.settings && user.settings.streak}
            </div>
            <div>
              <b>Language:</b> {user.language}
            </div>
            <div>
              <b>Registration date:</b> {formatDate(user.createdAt)}
            </div>
            <UserDevices device={user.device || null} versions={versions} />
            <UserSubscription
              onPressGiveFreePostcard={giveFreePostcard}
              subscription={user.subscription || {}}
            />
            <div>
              <h5>Troubleshoot</h5>
              <b>Notifications</b>
              {
                (user.troubleshoot
                  && user.troubleshoot.notifications
                  && user.troubleshoot.notifications.date)
                  ? (
                    <ul>
                      <li>
                        Date:
                        {' '}
                        {formatDate(user.troubleshoot.notifications.date)}
                      </li>
                      <li>
                        Success:
                        {' '}
                        {user.troubleshoot.notifications.success ? '✅' : '❌'}
                      </li>
                      {!user.troubleshoot.notifications.success && (
                        <li>
                          Next steps:
                          {' '}
                          {formatNotificationFailureReason(
                            user.troubleshoot.notifications.failureReason,
                          )}
                        </li>
                      )}
                    </ul>
                  )
                  : (
                    <p>Never started</p>
                  )
              }
            </div>
            {user && user._id && <ReferralInfos userId={user._id} />}
            <div>
              <b>Amplitude User Lookup:</b>
              {' '}
              <a href={amplitudeURL}>URL</a>
              {' '}
              with user ID:
              {' '}
              <b>{user._id}</b>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const UserData = ({ userData, email }) => (
  <Container>
    <Card>
      <CardBody>
        <CardTitle>
          User data
        </CardTitle>
        <UserDataTable email={email} user={userData} />
        <SendResetPasswordEmail email={email} />
        <ResetPassword email={email} />
      </CardBody>
    </Card>
  </Container>
);

const styles = {
  giveFreePostcard: {
    color: 'cornflowerblue',
    cursor: 'pointer',
    marginLeft: 7,
    textDecoration: 'underline',
  },
  subscriptionStatus: (active) => ({
    ...(active ? { color: 'green', fontWeight: 'bold' } : {}),
  }),
};

export default UserData;



// WEBPACK FOOTER //
// ./src/components/user-info/user-data.js